import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-businessAnalysis",
  "use": "icon-businessAnalysis-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 25 25\" id=\"icon-businessAnalysis\"><defs><clipPath id=\"icon-businessAnalysis_master_svg0_92_07583\"><rect x=\"0\" y=\"0\" width=\"25\" height=\"25\" rx=\"0\" /></clipPath></defs><g clip-path=\"url(#icon-businessAnalysis_master_svg0_92_07583)\"><g><g></g><g><path d=\"M13.1,5C14.2513,4.999636245,15.2082,5.886955,15.2945,7.035L15.3,7.2L15.3,24.8L8.7,24.8L8.7,7.2C8.699639999999999,6.04871,9.58696,5.091846,10.735,5.00550013L10.9,5L13.1,5ZM20.8,10.5C22.015,10.5,23,11.48497,23,12.7L23,22.6C23,23.815,22.015,24.8,20.8,24.8L17.5,24.8L17.5,10.5L20.8,10.5ZM6.5,13.8L6.5,24.8L3.2,24.8C1.984974,24.8,1,23.815,1,22.6L1,16C1,14.78497,1.984974,13.8,3.2,13.8L6.5,13.8Z\" fill=\"#E354D4\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/businessAnalysis.svg
// module id = 9k8H
// module chunks = 119